import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function SkeletonImage({ src, alt, className, aspectRatio = "16/9" }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div style={{ position: "relative", width: "100%", aspectRatio: aspectRatio }}>
      
      {!loaded && (
        <Skeleton
          style={{
            position: "absolute",
            top: 0, left: 0,
            width: "100%",
            height: "100%",
            borderRadius: "8px",
          }}
        />
      )}

      <img
        src={src}
        alt={alt}
        className={className}
        onLoad={() => setLoaded(true)}
        style={{
          position: "absolute",
          top: 0, left: 0,
          width: "100%",
          height: "100%",
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.4s ease",
        }}
      />
    </div>
  );
}

export default SkeletonImage;